import React from "react";

export default function LeaderboardPage({ navigateTo }: { navigateTo: (path: string) => void }) {
  return (
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div className="card" style={{ padding: 28 }}>
        <div className="label-accent" style={{ marginBottom: 12 }}>QUIT</div>
        <h1 style={{ margin: 0, fontSize: 46, lineHeight: 1.05 }}>Leaderboard</h1>
        <p className="text-muted" style={{ fontSize: 16, lineHeight: 1.6, marginBottom: 0 }}>
          Coming soon...
        </p>
      </div>
    </div>
  );
}
